export default {
  init() {
    // JavaScript to be fired on the home page

    // Search
    // Variables
    var overlay = document.querySelector('.overlay');
    var search = document.querySelector('.input-search');

    // Focus on an element
    var focusOn = function(element) {
      // Only focus on the element if it contains the relevant
      // class name that means it’s actually visible
      if (overlay.classList.contains('showing')) {
        element.focus();
      }
      // Otherwise remove the focus from the element
      else {
        element.blur();
      }
    }

    // Toggles a set of class names on an element
    var toggler = function() {
      // Toggle the classes which set off the transition
      overlay.classList.toggle('hiding');
      overlay.classList.toggle('showing');

      // Once the overlay’s transition ends focus the search field
      overlay.addEventListener('transitionend', focusOn.bind(null, search), false);

      // Prevent the clicks from navigating away
      return false;
    }
    $('.search-button').on('click', function(event){
      event.preventDefault();
      toggler();
    });
    $('.button-close').on('click', function(event){
      event.preventDefault();
      toggler();
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js